import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

type Props = {
  className: string;
};

export const RequiredLabel = ({ ...props }: Props) => {
  return (
    <Label className={props.className}>
      <span>必須</span>
    </Label>
  );
};

type StyledProps = {};

const Label = styled.span<StyledProps>`
  display: inline-block;
  font-size: 0;
  padding: 2px;
  background-color: ${StyleConfig.COLOR.SECONDORY};
  > span {
    font-size: 9px;
    line-height: 1;
    font-weight: bold;
    color: #fff;
  }
`;

export default RequiredLabel;
